import React, { useState, useEffect } from 'react';
import { FiDollarSign, FiSave, FiRefreshCw } from 'react-icons/fi';
import './Admin.css';

const UpdateRounding = () => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatingStoreId, setUpdatingStoreId] = useState(null);

  const roundingOptions = [
    { value: '0', label: 'None' },
    { value: 'RU', label: 'Round Up' },
    { value: 'RD', label: 'Round Down' },
    { value: 'RN', label: 'Round to Nearest' }
  ];

  useEffect(() => {
    fetchStores();
  }, []);

  const fetchStores = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://doticom.vn:3000/stores');
      if (response.ok) {
        const data = await response.json();
        setStores(data);
      } else {
        console.error('Failed to fetch stores');
      }
    } catch (error) {
      console.error('Error fetching stores:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateStoreRounding = async (storeId, lamTron) => {
    try {
      setUpdatingStoreId(storeId);
      const response = await fetch('https://doticom.vn:3000/update-amount-rounding', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: storeId, lamTron })
      });

      const result = await response.json();
      if (response.ok) {
        alert('Cập nhật quy tắc làm tròn thành công!');
        setUpdatingStoreId(null);
        fetchStores();
      } else {
        setUpdatingStoreId(null);
        alert(result.message || 'Có lỗi xảy ra');
      }
    } catch (error) {
      console.error('Error updating rounding:', error);
      setUpdatingStoreId(null);
      alert('Có lỗi xảy ra khi cập nhật quy tắc làm tròn');
    }
  };

  const handleRoundingUpdate = (storeId, event) => {
    event.preventDefault();
    const formElement = event.target.closest('tr');
    const lamTron = formElement.querySelector('.lam-tron').value;
    updateStoreRounding(storeId, lamTron);
  };

  return (
    <div className="admin-layout">
      <div className="admin-main" style={{ marginLeft: 0 }}>
        <header className="admin-header">
          <div className="header-left">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiDollarSign size={32} color="#495057" />
              <div>
                <h1>Cập nhật quy tắc làm tròn</h1>
                <p>Quản lý quy tắc làm tròn tiền cho các cửa hàng</p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <button 
              className="btn btn-primary"
              onClick={fetchStores}
              disabled={loading}
            >
              <FiRefreshCw className={loading ? 'spinning' : ''} />
              {loading ? 'Đang tải...' : 'Làm mới'}
            </button>
          </div>
        </header>

        <div className="content-section">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Đang tải...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Mã cửa hàng</th>
                        <th>Tên cửa hàng</th>
                        <th>Quy tắc làm tròn</th>
                        <th>Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stores.map(store => (
                        <tr key={store.IDCH}>
                          <td>{store.IDCH}</td>
                          <td>{store.MaPB}</td>
                          <td>{store.TenCuaHang}</td>
                          <td>
                            <select className="form-select lam-tron" defaultValue={store.LamTron || '0'}>
                              {roundingOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={(e) => handleRoundingUpdate(store.IDCH, e)}
                              disabled={loading || updatingStoreId === store.IDCH}
                            >
                              {updatingStoreId === store.IDCH ? (
                                <FiRefreshCw className="me-1 spinning" />
                              ) : (
                                <FiSave className="me-1" />
                              )}
                              {updatingStoreId === store.IDCH ? 'Đang cập nhật...' : 'Cập nhật'}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateRounding;
